const CancelBin = ()=>{
    return (<svg width="19" height="17" viewBox="0 0 19 17" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M16.6923 4.26923L16.1474 13.5382C16.1181 14.0377 15.8989 14.5072 15.5347 14.8505C15.1705 15.1937 14.689 15.3848 14.1885 15.3846H4.81149C4.31104 15.3848 3.82945 15.1937 3.46529 14.8505C3.10112 14.5072 2.88192 14.0377 2.85256 13.5382L2.30769 4.26923M7.53846 7.86538L9.5 9.82692M9.5 9.82692L11.4615 11.7885M9.5 9.82692L11.4615 7.86538M9.5 9.82692L7.53846 11.7885M1.98077 4.26923H17.0192C17.5606 4.26923 18 3.82985 18 3.28846V1.98077C18 1.43938 17.5606 1 17.0192 1H1.98077C1.43938 1 1 1.43938 1 1.98077V3.28846C1 3.82985 1.43938 4.26923 1.98077 4.26923Z" 
//stroke="#4B5563"
stroke="currentColor"
 stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
</svg>)
}

export default CancelBin;